import { FC } from 'react'
import { TopBarNavIconItem } from '@reapit/elements'
import { SecondaryNavigationMenu } from '../types'
import { useNavigationHandler } from '../utils'

interface SecondaryMenuItemProps extends SecondaryNavigationMenu {}

/**
 * Renders a single navigation item in the top bar.
 *
 * Uses React Router’s `useHref` to generate the `href`, highlights
 * the item when it matches the active key, and calls back when clicked.
 *
 * @param onClick       Function to invoke when this menu item is clicked.
 * @param title          Text label to display for the navigation item.
 * @param href           Route path or URL this item links to.
 * @returns              A `<TopBarNavIconItem>` that behaves like a link.
 */
export const SecondaryMenuItem: FC<SecondaryMenuItemProps> = ({ onClick, label, href, icon, hasBadge }) => {
  const navHandler = useNavigationHandler(href, onClick)
  return <TopBarNavIconItem {...navHandler} aria-label={label as string} icon={icon} hasBadge={hasBadge} />
}
